/**
 * Created with IntelliJ IDEA.
 * User: shlomif
 * Date: 4/27/14
 * Time: 3:11 PM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {
    "use strict";

    var Marionette = require("marionette");
    var template = require("templates/top-level-menu/topLevelMenuStatusList.tmpl");
    var TopLevelMenuStatusItemView = require("views/top-level-menu/TopLevelMenuStatusItemView");
    var TopLevelMenuCustomReasonListView = require("views/top-level-menu/TopLevelMenuCustomReasonListView");

    var TopLevelMenuStatusListView = Marionette.CompositeView.extend({
        template: template,
        itemView: TopLevelMenuStatusItemView,
        itemViewContainer: ".top-level-menu-status-list",
        withUIComponents:true,
        clickedModel: null,
        ui: {
            customReasonsContainer: ""
        },

        initialize: function(options) {
            this.LE = options.LE;
            this.customReasonsCollection = this.LE.crossModule("dataModule", this.LE.media.actions.request, this.LE.mediaCodes.dataModule.reqres.getAgentReasonsCollection);
            this.listenTo(this, "itemview:click", this._onStatusItemClicked);
            this.listenTo(this.collection,"change", this.render);

            if (this.customReasonsCollection.isCollectionAllowed()) {
                this._extendStatusCollection();
                this.listenTo(this.collection, "add", this._extendStatusCollection);
                this.listenTo(this.customReasonsCollection, "fetch:success", this._onCustomReasonsCollectionFetchSuccess);
            }
        },
        _onCustomReasonsCollectionFetchSuccess: function() {
            this._extendStatusCollection();
            this.LE.userBarMenu.redrawCurrentStatusItem();
        },
        _extendStatusCollection: function() {
            this.collection.each(_.bind(function(statusModel) {
                var modelCustomReasonsArr = this.customReasonsCollection.where({state:statusModel.getValue()});
                statusModel.setCustomReasons(modelCustomReasonsArr);
            }, this));
        },
        _onStatusItemClicked: function(childView, e) {
            this.clickedModel = childView.model;
            if (_.isEmpty(childView.model.getCustomReasons())) {
                this._selectState();
            }
            else {
                e.stopPropagation(); // if we need to open a list we need to stop the propagation so no outside click will be triggered. (it's triggered because we add this DOM object dynamically)
                this._showCustomReasons();
            }
        },

        _onStatusReasonItemClicked: function(componentId, eventName, customReasonItemView) {
            var reasonId = customReasonItemView.model.id;
            this.clickedModel.setSelectedReason(reasonId);
            this._selectState();
        },

        _selectState: function() {
            var callback = this.clickedModel.getCallback();
            if (_.isFunction(callback)) {
                var context = this.clickedModel.getContext() ? this.clickedModel.getContext() : this;
                var reason = this.clickedModel.getSelectedReason();
                callback.call(context, reason);
            }

            this.collection.each(_.bind(function(model){
                model.setSelected(this.clickedModel === model);
            }, this));

            this.trigger("item:click");
        },

        _showCustomReasons: function() {
            this.collection.each(_.bind(function(model){
                model.setOpen(this.clickedModel === model);
            }, this));

            if (!_.has(this.uiComponents, "customReasons")) {
                this.uiComponents.host$.createAndRender("customReasons", {
                    type : TopLevelMenuCustomReasonListView,
                    options : {
                        container: this.$el,
                        statusModel: this.clickedModel
                    },
                    events : {
                        "item:click" : "_onStatusReasonItemClicked"
                    }
                });
            }
        },

        closeCustomReasons: function() {
            this.collection.each(function(model){
                model.setOpen(false);
            });

            if (this.uiComponents.customReasons) {
                this.uiComponents.customReasons.close();
            }
        }
    });

    return TopLevelMenuStatusListView;
});
